import React from 'react'
import '../../App.css'
import AboutUs from '../AboutUs';

export default function Build()
{
    return (        <>
        <AboutUs />

        </>)

}